import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import extensions from 'app/extensions';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor, LogLevel } from 'angular-auth-oidc-client';
import { InternalAuthInterceptor } from './app/interceptors/auth.interceptor';
import { WINDOW_TOKEN } from './app/window-token';
import { windowProvider } from './app/window-provider';
import { CookieService } from 'ngx-cookie-service';
import { provideRouter } from '@angular/router';
import { routes } from './app/models/routes';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AppComponent } from './app/components/app/app.component';
import { provideAuth } from 'angular-auth-oidc-client';
import { AuthType } from 'app/models/auth-type';

if (environment.enableProdMode) {
    enableProdMode();
}

extensions();

const AUTH_LOG_LEVEL = environment.production ? LogLevel.None : LogLevel.Warn;

export function getAuthProvider() {
    return provideAuth(
        {
            config: [
                {
                    configId: AuthType.CUSTOMER_FORTICLOUD,
                    authority: `https://cognito-idp.us-east-1.amazonaws.com/${environment.cognitoPool}`,
                    postLoginRoute: 'login',
                    redirectUrl: `${window.location.origin}/login`,
                    postLogoutRedirectUri: `${window.location.origin}/logout`,
                    clientId: environment.clientId,
                    scope: 'aws.cognito.signin.user.admin openid',
                    responseType: 'code',
                    disablePkce: false,
                    autoUserInfo: false,
                    useRefreshToken: true,
                    secureRoutes: [environment.provisioningApi],
                    renewTimeBeforeTokenExpiresInSeconds: 10,
                    logLevel: AUTH_LOG_LEVEL
                },
                {
                    configId: AuthType.EMPLOYEE_FAC,
                    authority: `https://cognito-idp.us-east-1.amazonaws.com/${environment.facCognitoPool}`,
                    postLoginRoute: 'admin',
                    redirectUrl: `${window.location.origin}/admin/login`,
                    postLogoutRedirectUri: `${window.location.origin}/logout`,
                    clientId: environment.facCognitoClientId,
                    scope: 'openid email profile',
                    responseType: 'code',
                    disablePkce: false,
                    useRefreshToken: true,
                    autoUserInfo: false,
                    secureRoutes: [environment.adminApi],
                    renewTimeBeforeTokenExpiresInSeconds: 10,
                    logLevel: AUTH_LOG_LEVEL
                }
            ],
        },
    )
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, FormsModule, NgxChartsModule),
        provideNoopAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        getAuthProvider(),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: InternalAuthInterceptor, multi: true },
        { provide: WINDOW_TOKEN, useFactory: windowProvider },
        CookieService,
        provideRouter(routes)
    ]
}).catch(err => console.error(err));

